/**
 * Cupom fiscal (NFC-e) na landing — oculto em rostech.com.br até liberar o módulo.
 */
export const NFCE_CUPOM_FEATURE_KEY = 'nfce_cupom';

function readEnvFlag(): boolean | null {
  const raw = String(process.env.REACT_APP_NFCE_CUPOM_UI_ENABLED || '').trim().toLowerCase();
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return null;
}

function isDevHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  return host === 'localhost' || host === '127.0.0.1' || host === 'dev.rostech.com.br';
}

export function isNfceCupomUiEnabled(): boolean {
  const env = readEnvFlag();
  if (env !== null) return env;
  return isDevHost();
}

export function isNfceCupomFeatureKey(key: string): boolean {
  return key === NFCE_CUPOM_FEATURE_KEY;
}

export function filterNfceCupomFeatures<T extends { key: string }>(features: T[]): T[] {
  if (isNfceCupomUiEnabled()) return features;
  return features.filter((feature) => !isNfceCupomFeatureKey(feature.key));
}
